import React from "react";
import PartnerSection from "@modules/study/common/sections/partner/partner";
import UniPageBookingSection from "@modules/study/unipages/section_booking";

import {
  UniPageDiversifyHero,
  UniPageDiversifyTechnology,
  UniPageDiversifyCollaboration,
  UniPageDiversifyMarket,
  UniPageDiversifyToolkit,
  UniPageDiversifyPartnerSay,
} from "@modules/study/unipages/diversify";
import { LayoutUniversityPage } from "@unisearch/theme/layout";

const Diversify = () => {
  return (
    <LayoutUniversityPage
      title="International Student Recruitment Strategy | UniSearch for University Diversify"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/university/diversify`}
    >
      <UniPageDiversifyHero />
      <PartnerSection />
      <UniPageDiversifyTechnology />
      <UniPageDiversifyCollaboration />
      <UniPageDiversifyMarket />
      <UniPageDiversifyToolkit />
      <UniPageDiversifyPartnerSay />
      <UniPageBookingSection />
    </LayoutUniversityPage>
  );
};

export default Diversify;
